import { HiOutlineMail } from 'react-icons/hi';
import { FaWhatsapp } from 'react-icons/fa';

const data = [
    { id: 1, icon: <HiOutlineMail />, link: 'mailto:sancheznarro.pablo@gmail.com' },
    { id: 2, icon: <FaWhatsapp />, link: 'https://wa.me/+34684710945' }
];

export default data;